import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			meta: {
				title: '登录'
			},
			component: (resolve) => require(['../views/login/index.vue'], resolve)
		},
		{
			path: '/index',
			meta: {
				title: '运营管理系统'
			},
			component: (resolve) => require(['../views/index/index.vue'], resolve),
			children: [
				// {
				// 	path: '/index/home',
				// 	meta: {
				// 		title: '首页'
				// 	},
				// 	component: (resolve) => require(['../views/home/tz.vue'], resolve),
				// },
				{
					path: '/index/home1',
					meta: {
						title: '开发首页'
					},
					component: (resolve) => require(['../views/home/index.vue'], resolve),
				},
				{
					path: '/index/home2',
					meta: {
						title: '业务首页'
					},
					component: (resolve) => require(['../views/home2/index.vue'], resolve),
				},
				{
					path: '/index/home3',
					meta: {
						title: '管理员首页'
					},
					component: (resolve) => require(['../views/home3/index.vue'], resolve),
				},
				{
					path: '/index/sjzx',
					meta: {
						title: '数据中心'
					},
					component: (resolve) => require(['../views/dataCenter/index.vue'], resolve)
				},
				{
					path: '/index/qysj',
					name: 'qysj',
					meta: {
						title: '企业数据'
					},
					component: (resolve) => require(['../views/enterpriseData/index.vue'], resolve),
					children: [{
						path: '/index/qysj/qyxq',
						meta: {
							title: '企业数据'
						},
						component: (resolve) => require([
							'../views/enterpriseData/enterpriseDetail.vue'
						], resolve),
					}]
				},
				{
					path: '/index/rjbb',
					name: 'rjbb',
					meta: {
						title: '软件项目管理'
					},
					component: (resolve) => require(['../views/softwareVersion/index.vue'], resolve)
				},
				{
					path: '/index/ywbb',
					name: 'rjxm',
					meta: {
						title: '业务报备'
					},
					component: (resolve) => require(['../views/reported/index.vue'], resolve)
				},
				{
					path: '/index/dzxq_v2',
					name: 'dzxq_v2',
					meta: {
						title: '定制需求_v2'
					},
					component: (resolve) => require(['../views/dz_softwareVersion/index.vue'], resolve)
				},
				{
					path: '/index/yjbb_v2',
					name: 'yjxm_v2',
					meta: {
						title: '硬件项目管理_v2'
					},
					component: (resolve) => require(['../views/yj_softwareVersion/index.vue'], resolve)
				},
				{
					path: '/index/jkwd',
					name: 'yjxm',
					meta: {
						title: '接口文档管理'
					},
					component: (resolve) => require(['../views/hickyDocument/index.vue'], resolve)
				},
				// {
				// 	path: '/index/yjbb',
				// 	name: 'yjxm',
				// 	meta: {
				// 		title: '硬件项目管理'
				// 	},
				// 	component: (resolve) => require(['../views/hardwareVersion/index.vue'], resolve)
				// },
				// {
				// 	path: '/index/dzxq',
				// 	name: 'dz',
				// 	meta: {
				// 		title: '定制需求'
				// 	},
				// 	component: (resolve) => require(['../views/requirement/index.vue'], resolve)
				// },
				// 设置管理
				{
					path: '/index/szgl/zhsz',
					meta: {
						title: '账号设置'
					},
					component: (resolve) => require(['../views/setting/accountSetting.vue'], resolve)
				},
				{
					path: '/index/wdgl',
					meta: {
						title: '文档管理'
					},
					component: (resolve) => require(['../views/documentManagement/index.vue'], resolve)
				},
				{
					path: '/index/xqgl',
					meta: {
						title: '需求管理'
					},
					component: (resolve) => require(['../views/xq/index.vue'], resolve)
				},
				// {
				// 	path: '/index/app',
				// 	meta: {
				// 		title: 'APP版本管理'
				// 	},
				// 	component: (resolve) => require(['../views/appManagement/index.vue'], resolve)
				// },
				{
					path: '/index/app_v2_nei',
					meta: {
						title: 'APP版本管理_v2'
					},
					component: (resolve) => require(['../views/appManagement_v2/index.vue'], resolve)
				},
				{
					path: '/index/app_v2',
					meta: {
						title: 'APP版本管理_v2'
					},
					component: (resolve) => require(['../views/appManagement_v2/talga.vue'], resolve)
				},
				{
					path: '/index/xsgl',
					meta: {
						title: '销售管理'
					},
					component: (resolve) => require(['../views/sale/index.vue'], resolve)
				},
				{
					path: '/index/sfmx',
					meta: {
						title: '算法模型'
					},
					component: (resolve) => require(['../views/algorithmModel/index.vue'], resolve)
				}, {
					path: '/index/mxbz',
					meta: {
						title: '模型标注'
					},
					component: (resolve) => require(['../views/mxbz/index.vue'], resolve)
				},
				{
					path: '/index/zdbz',
					meta: {
						title: '自动标注'
					},
					component: (resolve) => require(['../views/AutomaticDimension/index.vue'], resolve)
				},
				{
					path: '/index/csgjsb',
					meta: {
						title: '测试工具上报'
					},
					component: (resolve) => require(['../views/testToolReporting/index.vue'], resolve)
				},
				{
					path: '/index/sjtj',
					meta: {
						title: '数据统计'
					},
					component: (resolve) => require(['../views/statistics/index.vue'], resolve)
				},
				{
					path: '/index/bfjl',
					meta: {
						title: '拜访记录'
					},
					component: (resolve) => require(['../views/visitLog/index.vue'], resolve)
				},
				{
					path: '/index/yjjc',
					meta: {
						title: '样机借测管理'
					},
					component: (resolve) => require(['../views/prototypeTest/index.vue'], resolve)
				}
			]
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js